import {defineAsyncComponent} from 'vue';

export const FormBuilder = defineAsyncComponent(
  () => import('./components/Form.vue')
);
